export default "__VITE_ASSET__cf541565__"